module.exports = __webpack_public_path__ + "static/media/25-7.8efbd7f8.mp3";